import i18n from "components/i18n/i18n";
import { ValueTextTokenElement } from "./valueTextToken";
import template from "./groupValueTextToken.hbs";


export class GroupValueTextTokenElement extends HTMLElement {

    private _shadowRoot: ShadowRoot;
    private element: HTMLSpanElement;

    private _data: TokenData[];
    private _readOnly: boolean;
    private container: HTMLDivElement;
    private _valid: boolean;
    private visited: any;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });

        //Anadimos template HBS
        const templateHBS = document.createElement("template");
        templateHBS.innerHTML = template();
        this._shadowRoot.appendChild(templateHBS.content.cloneNode(true));

        this.element = this._shadowRoot.querySelector("#tokens") as HTMLSpanElement;
        this.container = this._shadowRoot.querySelector(".container") as HTMLDivElement;
        if(this.hasAttribute("hasRightIcon")) {
            this.container.style.paddingRight = "25px";
        }

        this.bindEvents();
    }

    private bindEvents(): void {

        //Se elimina por el tag del value
        this.element.addEventListener("removeToken", (evt) => {

            let token: ValueTextTokenElement = (evt.target as ValueTextTokenElement);

            let idx = (this._data as any[]).findIndex(i => i.value === token.data);
            this._data.splice(idx, 1);

            this.element.removeChild(token);
            this.dispatchEvent(new Event("change"));
        });

        this.element.addEventListener("click", (evt) => {
            this.focus();
            evt.stopPropagation();
        });
    }

    private connectedCallback() {
        this.upgradeProperty();
    }

    private upgradeProperty() {
        for (const key in this) {
            if (this.hasOwnProperty(key)) {
                let value = this[key];
                delete this[key];
                this[key] = value;
            }
        }
    }

    private render() {
        this.element.innerHTML = "";
        for (const tokenData of this._data ?? []) {
            let token = this.createTextToken(tokenData);
            this.element.append(token);
        }
        if (this._readOnly) {
            this.container.classList.add("read-only");
            this.element.classList.add("read-only");
        } else {
            this.container.classList.remove("read-only");
            this.element.classList.remove("read-only");
        }
    }

    private createTextToken(tokenData: TokenData) {
        let token = document.createElement("s6-value-text-token");

        let tokenValue = document.createAttribute("value");
        token.setAttributeNode(tokenValue);
        token.innerText = this.createInnerTextToken(tokenData);
        tokenValue.value = tokenData.value;
        if (this._readOnly) {
            token.setAttribute("readonly", "");
        }
        return token;
    }

    private createInnerTextToken(tokenData: TokenData): string {

        let text = "";
        if (tokenData.codeInOptionLabel) {
            text += tokenData.value + " - ";
        }
        if (tokenData.translate) {
            text += i18n.instance.t(tokenData.text);
        } else {
            text += (tokenData.text ?? "");
        }

        return text;
    }

    public set data(data: any[]) {
        this._data = data;
        this.render();
    }

    public get data() {
        if (this._data?.length === 0) {
            return null;
        }
        return this._data;
    }

    public set readOnly(ro: boolean) {
        if (ro) {
            this.setAttribute("readonly", "true");
        } else {
            this.removeAttribute("readonly");
        }
        this._readOnly = ro;
    }

    public set valid(valid: boolean) {
        this._valid = valid ?? true;
        if (this._valid) {
            this.container.classList.remove("has-error");
            this.container.classList.remove("is-pending");
        } else if (this.visited) {
            this.container.classList.add("has-error");
        } else {
            this.container.classList.add("is-pending");
        }
    }

    public set validationMessage(message) {
        if (message == null) {
            this._shadowRoot.querySelector("s6-tooltip")?.remove();
        } else {
            let tooltip = document.createElement("s6-tooltip");
            tooltip.innerHTML = message;
            this._shadowRoot.append(tooltip);
        }
    }

    public focus() {
        this.visited = true;
        this.container.classList.add("focused");
    }

    public blur() {
        this.valid = this._valid;
        this.container.classList.remove("focused");
    }
}

export function initGroupValueTextTokenWebComponent() {
    window.customElements.define("s6-group-value-text-token", GroupValueTextTokenElement);
}


export interface TokenData {
    text: string;
    value: string;
    translate?: boolean;
    tooltip?: string;
    codeInOptionLabel?: boolean;
}
